import { useState } from "react"
import { useEffect } from "react"
import { useRef } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { SITE_ID_FETCH_SUCCESS } from "../../../../Reducer/SiteIdSlice"
import API, { cancelAllRequests, createController } from "../../../../Network/API"
import DcTab from "../DcTab"
import ReactEcharts from "echarts-for-react";
import * as echarts from 'echarts'
export default function DcGraph() {
    const [chartData, setChartData] = useState(null)
    const ddd = useParams();
    const dispatch = useDispatch()
    const [dateValue, setDateChange] = useState(new Date().toISOString().slice(0, 10))
    const [filterType, setFilterType] = useState('today');
    const [showModal, setShowModal] = useState(false);
    const [tempDate, setTempDate] = useState(new Date().toISOString().slice(0, 10));
    const [step, setStepNumber] = useState(1)
    const onDateChange = (value) => {
        setDateChange(value)
        if (step == 1) {
            dc_voltage_load(value)
        }
    }

    useEffect(() => {
        if (showModal) {
            setTempDate(dateValue);
        }
        dc_voltage_load(dateValue);
    }, [showModal, dateValue]);

    const dc_voltage_load = (value) => {
        cancelAllRequests();
        const controller = createController();
        const signal = controller.signal;
        API.get('/v1/oauth/dc_voltage?site_id=' + ddd.id + '&date=' + value, { signal })
        .then((response) => {
            setChartData(response.data)
        }).catch((error) => {

        });
    }


    const setStep = (number) => {
        setStepNumber(number)
        if (number == 1) {
            // dc_voltage_load(dateValue)
        }

    }


    useEffect(() => {

        dispatch(SITE_ID_FETCH_SUCCESS(ddd.id))

        dc_voltage_load(dateValue)


    }, [ddd.id]);

    const getMaxPoint = (data = []) => {
        let max = -Infinity
        let index = -1

        data.forEach((v, i) => {
            if (v > max) {
                max = v
                index = i
            }
        })

        return { max, index }
    }

    const buildOption = (type, unit) => {
        if (!chartData) return {}

        const colors = ['#008000', '#FFC300', '#1f77b4']
        const series = []
        const legendData = []

        Object.keys(chartData.tenants).forEach((tenantId, index) => {
            const tenant = chartData.tenants[tenantId]
            const color = colors[index % colors.length]

            legendData.push(tenant.name)

            // 🔹 MAIN LINE (legend color comes from here)
            series.push({
                name: tenant.name,
                type: 'line',
                symbol: 'none',
                sampling: 'lttb',
                lineStyle: { color },
                itemStyle: { color },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color },
                        { offset: 1, color: 'rgba(255,255,255,0.15)' }
                    ])
                },
                data: tenant[type]
            })

            // 🔹 MAX POINT (❌ legend এ যাবে না)
            const max = Math.max(...tenant[type])
            const maxIndex = tenant[type].indexOf(max)

            if (maxIndex !== -1) {
                series.push({
                    name: `${tenant.name}-max`,
                    type: 'scatter',
                    showInLegend: false,   // ✅ KEY LINE
                    symbolSize: 12,
                    z: 10,
                    itemStyle: { color },
                    label: {
                        show: true,
                        formatter: `Max: ${max} ${unit}\n${chartData.times[maxIndex]}`,
                        position: 'top',
                        fontSize: 10,
                        backgroundColor: '#fff',
                        padding: [4, 6],
                        borderRadius: 4
                    },
                    data: [[chartData.times[maxIndex], max]]
                })
            }
        })

        return {
            color: colors,   // ✅ IMPORTANT
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                top: 10,
                data: legendData   // ✅ only tenant names
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: chartData.times
            },
            yAxis: {
                type: 'value',
                axisLabel: { formatter: `{value} ${unit}` }
            },
            series
        }
    }


    return (
        <>
            <div className="row">
                <DcTab id={2} site_id={ddd.id} />
            </div>

            <div className="row ms-1 me-1">
                <div className="col-12 text-center">
                    <div class="btn-group btn-group-md">
                        <button type="button" class={`btn btn-outline-info   ${step == 1 ? 'btn-info' : 'bg-white'}`} onClick={() => setStep(1)}>Voltage</button>
                        <button type="button" class={`btn btn-outline-info   ${step == 2 ? 'btn-info ' : 'bg-white'}`} onClick={() => setStep(2)}>Current</button>
                        <button type="button" class={`btn btn-outline-info   ${step == 3 ? 'btn-info ' : 'bg-white'}`} onClick={() => setStep(3)}>Load(kW)</button>
                    </div>
                </div>
                <div className="col-md-12">

                    <div className="card shadow-sm border-0 bg-cc mt-2" style={{ minHeight: '300px' }}>
                        <div class="card-header  border-bottom card-title bg-white align-items-center d-flex">
                            <div class="flex-grow-1">
                                <b class="main-card-title mb-0">Graph: {step == 1 ? 'Voltage' : step == 2 ? 'Current' : step == 3 ? 'Load(kW)' : step == 4 ? 'DC Power(Hourly)' : step == 5 ? 'DC Power(Daily)' : step == 6 ? 'DC Load(W)' : ''}</b>
                                <p class="text-muted p-0 m-0">Duration: {dateValue}</p>
                            </div>
                            <div class="flex-shrink-0">
                                <div class="">
                                    <div class="input-group input-group-sm">
                                        <select
                                            className="form-select form-select-sm"
                                            value={filterType}
                                            onClick={(e) => {
                                                if (filterType === 'date') {
                                                    setShowModal(true);
                                                }
                                            }}
                                            onChange={(e) => {
                                                setFilterType(e.target.value);
                                                if (e.target.value === 'date') {
                                                    setShowModal(true);
                                                }
                                            }}
                                        >
                                            <option value="today">Today</option>
                                            <option value="date">Custom Date</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body bg-white">

                            {step === 1 && (
                                <ReactEcharts option={buildOption('voltage', 'V')} style={{ height: 300 }} />
                            )}

                            {step === 2 && (
                                <ReactEcharts option={buildOption('current', 'A')} style={{ height: 300 }} />
                            )}

                            {step === 3 && (
                                <ReactEcharts option={buildOption('load', 'kW')} style={{ height: 300 }} />
                            )}

                        </div>

                    </div>
                </div>
            </div>

            {/* Date Filter Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Date</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Select Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={tempDate}
                                        onChange={(e) => setTempDate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => {
                                        setDateChange(tempDate);
                                        setShowModal(false);
                                    }}
                                >
                                    <i className="fa-solid fa-filter me-1"></i>
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}